import { Record } from "../../components/record/Record";
import { Records } from "../../components/records/Records";
import { tabs } from "./eegDataTabs";
import { DetailTabs } from "../../components/detailTabs/DetailTabs";
import { Groups } from "../../components/groups/Groups";
import { eegDataOptions } from "./eegDataOptions";

export const eegDataFieldsQuery = [
    "*.*",
    "eeg_recording.eeg_evaluation.eeg_session.start_date",
    "eeg_recording.eeg_evaluation.eeg_session.treatment.client.client_id",
    "pair_electrode_location.electrode_location_one.*",
    "pair_electrode_location.electrode_location_two.*",
    "pair_frequency_bands.frequency_band_one.*",
    "pair_frequency_bands.frequency_band_two.*",
].join(",");

export const eegDataRoutes = [
    {
        path: "/eeg_data",
        element: <Records entity="eeg_data" fieldsQuery={eegDataFieldsQuery}/>,
    },
    {
        path: "/eeg_data/:id",
        element: <Record entity="eeg_data" type="detail" fieldsQuery={eegDataFieldsQuery} body={<DetailTabs tabs={tabs} />} />,
        children: [
            {
                path: "/eeg_data/:id/detail",
                element: <Groups groupsOptions={eegDataOptions.groupsOptions} />,
            },
        ],
    },
];
